"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipProvider = exports.Tooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const RadixTooltip = __importStar(require("@radix-ui/react-tooltip"));
const Div_1 = require("./Div");
const Text_1 = require("./Text");
const constants_1 = require("../constants");
const intent_1 = require("../constants/intent");
const Content = (0, styled_1.default)(RadixTooltip.Content)(({ background, color, linkColor }) => ({
    background,
    borderRadius: constants_1.theme.border.radius.small,
    boxShadow: constants_1.theme.boxShadow.normal,
    color,
    fontSize: 14,
    maxWidth: 160,
    a: {
        color: linkColor,
        fontWeight: constants_1.theme.font.weight.bold,
        textDecoration: 'underline',
    },
    zIndex: constants_1.theme.zIndex.tooltip,
}));
const TooltipContent = ({ children, text, side, intent, }) => {
    const { backgroundColor, color, linkColor } = (0, intent_1.getIntentProps)(intent);
    return ((0, jsx_runtime_1.jsxs)(Content, { side: side, background: backgroundColor, color: color, linkColor: linkColor, children: [(0, jsx_runtime_1.jsx)(RadixTooltip.Arrow, { fill: backgroundColor }), (0, jsx_runtime_1.jsxs)(Div_1.Div, { styles: { textAlign: 'center', p: 1 }, children: [text && (0, jsx_runtime_1.jsx)(Text_1.Text, { children: text }), children] })] }));
};
const Tooltip = ({ children, text, side, intent = 'info', open, }) => {
    return ((0, jsx_runtime_1.jsxs)(RadixTooltip.Root, { open: open, children: [text && ((0, jsx_runtime_1.jsx)(RadixTooltip.Portal, { children: (0, jsx_runtime_1.jsx)(TooltipContent, { text: text, side: side, intent: intent }) })), children] }));
};
exports.Tooltip = Tooltip;
Tooltip.Content = TooltipContent;
Tooltip.Trigger = RadixTooltip.Trigger;
const TooltipProvider = ({ children }) => ((0, jsx_runtime_1.jsx)(RadixTooltip.Provider, { children: children }));
exports.TooltipProvider = TooltipProvider;
